// src/pages/ServiceSwap.jsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomListing from "../components/CustomListing";
import { useDeviceApi } from "../api/device";
import { useOrganizationApi } from "../api/organization";
import ReusableHeader from "../components/ReusableHeader";
import CustomButton from "../components/CustomButton";
import ReusableFilter from "../components/ReusableFilter";
import "../styles/layout.css";
import { formatDate } from "../util/date";
import { toast } from "react-toastify";
import { decodeJwt } from "../util/decodeJwt";
import { useOrderApi } from "../api/orders";
import { Filter, RefreshCcw, Trash } from "lucide-react";
import CustomDropdown from "../components/CustomDropdown";
import CustomMultiSelectDropdown from "../components/CustomDropdown";
import QRScanner from "../components/QRBarcodeScanner";
import { BrowserMultiFormatReader } from "@zxing/browser";
export default function ServiceSwap() {
  const { deleteVendorDevice } =useOrderApi();
  const { getAllVendorOrg } = useOrganizationApi()
  const { getAllDeliveredDevices,swapMacAddress,getFreeDevices } = useDeviceApi();
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);

  const [isSwapOpen, setIsSwapOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [newMac, setNewMac] = useState("");


  // Filters
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  // Organizations
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [rows, setRows] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [searchText, setSearchText] = useState("");

  // From / To Date
const today = new Date();
const currentDate = today.toISOString().split("T")[0]; // "2025-09-26"

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [hasMounted, setHasMounted] = useState(false);

const [availableDevices, setAvailableDevices] = useState([]);
const [selectedNewDevice, setSelectedNewDevice] = useState("");

// scanner
const [showMacScanner, setShowMacScanner] = useState(false);
const fileInputRef = useRef(null);

  // Initialize filterObject as empty to show all records by default
  const [filterObject, setFilterObject] = useState({});

  // Decode user once
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = decodeJwt(token);
      setUserId(decoded?._id || null);
      setUserRole(decoded?.role?.toLowerCase() || "");
    }
  }, []);




  // Fetch organizations
  useEffect(() => {
    const fetchOrgs = async () => {
      try {
        const res = await getAllVendorOrg({ limit: 100, offset: 0 });
        if (res?.success && Array.isArray(res.data)) {
          setOrganizations(
            res.data.map((o) => ({ value: o._id, label: o.name }))
          );
        }
      } catch {
        toast.error("Failed to load organizations");
      }
    };
    fetchOrgs();
  }, []);

const fetchAvailableDevices = async () => {
  const res = await getFreeDevices();

  setAvailableDevices(
    res.data.map((d) => ({
      label: d.serialNumber,
      value: d._id,
    }))
  );
};

  const handleDelete = async (id) => {
    if (!userId) {
      toast.error("Unauthorized: User not found");
      return;
    }

    if (window.confirm("Are you sure you want to delete this device?")) {
      try {
        await deleteVendorDevice(id, userId);
        toast.success("Device deleted successfully");
        window.location.reload();
      } catch (err) {
        toast.error(err.message || "Failed to delete device");
      }
    }

  };

  const handleMacScanDetected = (data) => {
  try {
    const text = String(data).trim();

    if (!text) {
      toast.error("Invalid QR data");
      return;
    }

    setNewMac(formatMacAddress(text));
  } catch {
    toast.error("Failed to read QR");
  }

  setShowMacScanner(false);
};

const barcodeReader = useRef(new BrowserMultiFormatReader());

const handleMacFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    const reader = barcodeReader.current;

    const img = document.createElement("img");
    img.src = URL.createObjectURL(file);

    await new Promise((resolve) => (img.onload = resolve));

    const result = await reader.decodeFromImageElement(img);
    const text = result?.text?.trim();

    if (!text) {
      toast.error("Invalid QR/Barcode image");
      return;
    }

    setNewMac(formatMacAddress(text));
    toast.success("MAC detected");

  } catch {
    toast.error("Unreadable QR/Barcode image");
  }

  e.target.value = "";
};

  const openSwapDialog = (row) => {
      if (!row.manufacturerId) {
        toast.error("Manufacturer ID & MAC is not mapped for this device");
        return;
      }
  setSelectedDevice(row);
  setNewMac("");
  setSelectedNewDevice("");
  setIsSwapOpen(true);
  fetchAvailableDevices();
    };

  const handleSaveSwap = async () => {
   if (!newMac || !selectedNewDevice) {
      toast.error("Please select new device and enter MAC");
      return;
    }

    // ✅ MAC validation
    if (!isValidMacAddress(newMac)) {
      toast.error("Invalid MAC format (AA:BB:CC:DD:EE:FF)");
      return;
    }

    try {
      await swapMacAddress({
        oldDeviceId: selectedDevice._id,
        newDeviceId: selectedNewDevice,
        newMacAddress: newMac,
      });

      toast.success("Device swapped successfully");

      setIsSwapOpen(false);

      fetchWithFilters({ limit: 10, offset: 0 }).then((res) => {
        if (res?.success && Array.isArray(res.data)) setRows(res.data);
      });
    } catch (err) {
      toast.error(err.message || "Failed to swap device");
    }
  };

  const columns = [
       {
      key: "manufacturerId",
      label: "Machine Serial Number",
      render: (row) => row.manufacturerId==="" ? "N/A" : row.manufacturerId,
    },
      {
      key: "serialNumber",
      label: "BCU Serial Number",
      render: (row) => row.serialNumber==="" ? "N/A" : row.serialNumber,
    },

    {
      key: "macAddress",
      label: "MAC Address",
      render: (row) => row.macAddress=="" ? "N/A" : row.macAddress,

    },
    {
    key: "actions",
    label: "Actions",
    render: (row) => (
        <div className="action-buttons">
        <button
            className="swap-action-btn"
            onClick={() => openSwapDialog(row)}
        >
            <RefreshCcw size={16} />
            <span>Swap</span>
        </button>
        </div>
    ),
    },
    {
  key: "history",
  label: "MAC History",
  render: (row) => {
    const history = row.macHistory || [];

    if (!history.length) {
      return <span className="no-history">No changes</span>;
    }

    const latest = history[history.length - 1];

    return (
      <div className="history-cell">
        <div className="history-summary">
          <strong>{history.length}</strong> change{history.length > 1 ? "s" : ""}
        </div>

        <div className="history-date">
          {new Date(latest.timestamp).toLocaleDateString()}
        </div>

        <details className="history-expand">
          <summary>View</summary>

          <div className="history-popup">
            {history.map((h) => (
              <div key={h._id} className="history-line">
                #{h.sequence}: {h.oldMacAddress} → {h.newMacAddress}
              </div>
            ))}
          </div>
        </details>
      </div>
    );
  },
},
  ];

  const renderActionButtons = () => (
      <div className="header-buttons" style={{ display: "flex", alignItems: "center", width: "100%" }}>
        <input
          type="text"
          placeholder="Search inventory..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
         className="search-input"
        />
    </div>
  );

  const fetchWithFilters = async (params = {}) => {
    return await getAllDeliveredDevices({
      ...params,
      ...filterObject,
      search: searchText || undefined, // include search
    });
  };


useEffect(() => {
  if (!hasMounted) {
    setHasMounted(true);
    return;
  }

  const delayDebounce = setTimeout(() => {
    fetchWithFilters({ limit: 10, offset: 0 })
      .then((res) => {
        if (res?.success && Array.isArray(res.data)) {
          setRows(res.data);
        }
      })
      .catch(() => toast.error("Failed to fetch data"));
  }, 500);

  return () => clearTimeout(delayDebounce);
}, [searchText, filterObject]);

  // Apply filters
  const handleApplyFilters = async () => {
    const newFilters = {};

    // Organization
    if (selectedOrg) {
      const org = organizations.find((o) => o.value === selectedOrg);
      newFilters.organizationId = selectedOrg;
      newFilters.organizationName = org ? org.label : selectedOrg;
    }

    // From / To date
    newFilters.fromDate = fromDate;
    newFilters.toDate = toDate;

    setFilterObject(newFilters);
    setIsFilterOpen(false);
    toast.success("Filters applied");

    // Fetch filtered data
    try {
      const res = await getAllDeliveredDevices({ limit: 10, offset: 0, ...newFilters });
      if (res?.success && Array.isArray(res.data)) setRows(res.data);
    } catch {
      toast.error("Failed to fetch filtered data");
    }
  };

  // Remove filter
  const handleRemoveFilter = async (key) => {
    const updated = { ...filterObject };

    if (key === "organizationId") {
      delete updated.organizationId;
      delete updated.organizationName;
      setSelectedOrg("");
    }

    if (key === "fromDate") {
      delete updated.fromDate;
      setFromDate(currentDate);
    }

    if (key === "toDate") {
      delete updated.toDate;
      setToDate(currentDate);
    }

    setFilterObject(updated);

    // Fetch updated data
    try {
      const res = await getAllDeliveredDevices({ limit: 10, offset: 0, ...updated });
      if (res?.success && Array.isArray(res.data)) setRows(res.data);
    } catch {
      toast.error("Failed to fetch filtered data");
    }
  };

  // Active filters for chips
  const activeFilters = [];

  if (filterObject.deviceModelNames && filterObject.deviceModelNames.length > 0) {
    activeFilters.push({
      key: "deviceModelIds",
      label: "Model",
      value: filterObject.deviceModelNames.join(", "),
    });
  }

  if (filterObject.organizationName) {
    activeFilters.push({
      key: "organizationId",
      label: "Organization",
      value: filterObject.organizationName,
    });
  }

  if (filterObject.fromDate) {
    activeFilters.push({
      key: "fromDate",
      label: "From Date",
      value: filterObject.fromDate,
    });
  }

  if (filterObject.toDate) {
    activeFilters.push({
      key: "toDate",
      label: "To Date",
      value: filterObject.toDate,
    });
  }

  // Format MAC → AA:BB:CC:DD:EE:FF
  const formatMacAddress = (value) => {
    // remove non hex characters
    let cleaned = value.replace(/[^a-fA-F0-9]/g, "");

    // limit to 12 chars
    cleaned = cleaned.substring(0, 12);

    // split every 2 chars and join with :
    const pairs = cleaned.match(/.{1,2}/g);

    return pairs ? pairs.join(":").toUpperCase() : "";
  };
  // ✅ Validate MAC format
const isValidMacAddress = (mac) => {
  return /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/i.test(mac);
};

  return (
    <div className="inventoryManagement">
      <ReusableHeader title="Service Swap" children={renderActionButtons()} />

      {/* Active Filters Chips */}
      <div className="filter-chips-container">
        {activeFilters.map((filter, index) => (
          <div key={index} className="filter-chip">
            {filter.label}: {filter.value}
            <span className="remove-icon" onClick={() => handleRemoveFilter(filter.key)}>
              ✕
            </span>
          </div>
        ))}
      </div>

      <CustomListing
        data={rows}
        setData={setRows}
        fetchData={fetchWithFilters}
        columns={columns}
        pageSize={10}
        showCheckbox={false}   // ✅ THIS HIDES CHECKBOX
      />

      {/* Filter Modal */}
      <ReusableFilter
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        title="Filter Devices"
      >
        <div className="filter-fields">
        <div className="filter-field">
          <label className="filter-label">From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="date-input fancy-date"
          />
        </div>

        <div className="filter-field">
          <label className="filter-label">To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="date-input fancy-date"
          />
        </div>


          <div className="filter-actions">
            <CustomButton className="apply-btn" label="Apply" onClick={handleApplyFilters} />
            <CustomButton
              className="clear-btn"
              label="Clear"
              onClick={() => {
                setSelectedOrg("");
                setFromDate(currentDate);
                setToDate(currentDate);
                setFilterObject({});
                setIsFilterOpen(false);
                fetchWithFilters({ limit: 10, offset: 0 }).then(res => {
                  if (res?.success && Array.isArray(res.data)) setRows(res.data);
                });
              }}
            />
          </div>
        </div>
      </ReusableFilter>
      {/* 🔁 Swap MAC Dialog */}
    {isSwapOpen && selectedDevice && (
        <div className="swap-overlay">
          <div className="swap-modal">

            <h2 className="swap-title">Service Swap</h2>
            <p className="swap-subtitle">
              Replace this device with a new one
            </p>
            {/* SCANNER MODAL */}
            {showMacScanner && (
              <div className="dialog-scanner-wrapper">
                <QRScanner
                  onDetected={handleMacScanDetected}
                  onClose={() => setShowMacScanner(false)}
                />
              </div>
            )}

            {/* OLD DEVICE */}
            <div className="swap-field">
              <label>Current Device</label>
              <input
                type="text"
                value={`${selectedDevice.serialNumber} (${selectedDevice.macAddress})`}
                disabled
              />
            </div>

            {/* NEW DEVICE DROPDOWN */}
            <div className="swap-field">
              <label>Select New Device</label>

            <CustomMultiSelectDropdown
              label="Select New Device"
              options={availableDevices}
              value={selectedNewDevice}
              onChange={(val) => setSelectedNewDevice(val)}
              name="newDevice"
              isMultiSelect={false}
            />
            </div>

            {/* NEW MAC */}
           <div className="swap-field">
              <label>New MAC Address</label>

             <input
                type="text"
                value={newMac}
                onChange={(e) => setNewMac(formatMacAddress(e.target.value))}
                placeholder="AA:BB:CC:DD:EE:FF"
                maxLength={17} // 12 chars + 5 colons
              />
              <div className="button-group" style={{ marginTop: "20px" }}>
                {/* Scan camera */}
                <button
                  className="qr-btn scan-btn"
                  onClick={() => setShowMacScanner(true)}
                >
                  Scan QR
                </button>

                {/* Upload QR */}
                <button
                  className="qr-btn upload-btn"
                  onClick={() => fileInputRef.current.click()}
                >
                  Upload QR
                </button>

                <input
                  type="file"
                  ref={fileInputRef}
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleMacFileChange}
                />
                </div>
              </div>

            <div className="swap-actions">
              <button
                className="swap-cancel"
                onClick={() => setIsSwapOpen(false)}
              >
                Cancel
              </button>

              <button
                className="swap-save"
                onClick={handleSaveSwap}
              >
                Confirm Swap
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
